export const sliceActivities = (numberOfActions: number, activities: Array<any>) => {
  const activitiesLength = activities.length
  const diff = activitiesLength - numberOfActions
  let generatedActivities = activities.slice(0, numberOfActions)
  if (diff >= 0) {
    return generatedActivities
  }
  const repeatTimes = Math.floor(numberOfActions / activitiesLength)
  if (repeatTimes > 0) {
    for (let i = 1; i < repeatTimes; i++) {
      generatedActivities = generatedActivities.concat(activities)
    }
  }
  const remainder = numberOfActions % activitiesLength
  if (remainder > 0) {
    generatedActivities = generatedActivities.concat(activities.slice(0, remainder))
  }
  return generatedActivities
}
